import { render } from "./Split.vue?vue&type=template&id=0945310b"
import script from "./Split.vue?vue&type=script&lang=js"
export * from "./Split.vue?vue&type=script&lang=js"

import "./Split.vue?vue&type=style&index=0&id=0945310b&lang=css"
script.render = render

export default script